import { Container } from "inversify";
import { TokenContainerModule } from "inversify-token";
import { YinzCamInjectModule } from "yinzcam-inject";
import { CardsDataSourceToken } from "../common/CardsDataSourceToken";

import { YinzCamDropsServerCurrentDrop } from "./YinzCamDropsServerCurrentDrop/YinzCamDropsServerCurrentDrop";
import { YinzCamChatMedia } from "./YinzCamChatMedia/YinzCamChatMedia";
import { YinzCamSignonProfileSegment } from "./YinzCamSignonProfileSegment/YinzCamSignonProfileSegment";

export const CardsDataSourcesModule: YinzCamInjectModule = new YinzCamInjectModule((container: Container): void => {
  container.load(new TokenContainerModule((bindToken) => {
    bindToken(CardsDataSourceToken).to(YinzCamDropsServerCurrentDrop).whenTargetNamed("YinzCamDropsServerCurrentDrop");
    bindToken(CardsDataSourceToken).to(YinzCamChatMedia).whenTargetNamed("YinzCamChatMedia");
    bindToken(CardsDataSourceToken).to(YinzCamSignonProfileSegment).whenTargetNamed("YinzCamSignonProfileSegment");
  }));
});
